import type { DatabaseService, RepositoryHost } from '@core';
import { getPrestigeConfigurationRepository } from './prestige-configuration-repository';
import { getPricingConfigurationRepository } from './pricing-configuration-repository';

export const repositoryHost: RepositoryHost = {
  getPrestigeConfigurationRepository(databaseService: DatabaseService) {
    return getPrestigeConfigurationRepository(databaseService);
  },
  getPricingConfigurationRepository(databaseService: DatabaseService) {
    return getPricingConfigurationRepository(databaseService);
  },
};
